import api from "!../../../../../../releases/3ffcce440ca4929df438c174c69d5e9c4453e6fd/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../../../../releases/3ffcce440ca4929df438c174c69d5e9c4453e6fd/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[8].oneOf[1].use[1]!../../../../../../releases/3ffcce440ca4929df438c174c69d5e9c4453e6fd/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[8].oneOf[1].use[2]!../../../../../../releases/3ffcce440ca4929df438c174c69d5e9c4453e6fd/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[8].oneOf[1].use[3]!./admin.scss";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};